package nl.volleyplanner.web.controller.planner.planner_configurations

import kotlinx.browser.document
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.html.dom.create
import kotlinx.html.h1
import kotlinx.html.js.div
import nl.volleyplanner.api.auth.AuthLevel
import nl.volleyplanner.api.planner.PlannerConstraintConfiguration
import nl.volleyplanner.web.ApiDataStateFlow
import nl.volleyplanner.web.CoroutineManager
import nl.volleyplanner.web.base.StaticPageController
import nl.volleyplanner.web.base.WebPageController
import nl.volleyplanner.web.base.component
import nl.volleyplanner.web.controller.planner.PlannerIndexController
import nl.volleyplanner.web.service.WebUserAndOrganisationService
import org.w3c.dom.HTMLElement

class PlannerConfigurationController(override val parent: PlannerIndexController) : StaticPageController() {
    override val name = "PlannerConstraintConfigurationController"
    override val title = "Regels configuratie"
    override val path = "/configuratie/regels"
    override val requiredAuthLevel = AuthLevel.AdminUser
    override val childPages = emptyList<WebPageController>()

    private val plannerConfigurationsDataFlow = ApiDataStateFlow(
        "PlannerConfigurationData",
        AuthLevel.AdminUser,
        contextFlow = WebUserAndOrganisationService.selectedOrganisationState,
        coroutineScope = CoroutineManager.CONTROLLER_SCOPE
    ) { organisationContext ->
        organisationContext?.volleyplannerApiClient
            ?.organisation
            ?.plannerConfiguration
            ?.listPlannerConfigurations()
    }
    private val selectedConfigurationState = MutableStateFlow<PlannerConstraintConfiguration?>(null)

    override fun createRuntimeInstance() = PlannerConfigurationController(parent)

    override suspend fun renderContent(): HTMLElement {
        return document.create.div {
            h1(classes = "display-5") { +"Regels configuratie" }

            component(PlannerConfigurationVersionSelectionComponent(
                plannerConfigurationsDataFlow,
                selectedConfigurationState
            ))

            component(PlannerConfigurationComponent(
                plannerConfigurationsDataFlow,
                selectedConfigurationState.asStateFlow()
            ))
        }
    }
}